import { useNavigate } from 'react-router-dom'
import { NDT_SHORTCUTS, ShortcutTile, type NdtShortcut } from '@/components/ndt/ndtShortcuts'
import { ndtFormPath, setNdtExitPath } from '@/utils/ndtNavigation'

const LIFTING_SHORTCUTS = NDT_SHORTCUTS.filter((s) => s.group === 'lifting')

// Løft type selection page
const LoftSelection = () => {
  const navigate = useNavigate()

  const handleSelection = (shortcut: NdtShortcut) => {
    if (!shortcut.kind) {
      sessionStorage.setItem('inspectionType', 'ndt')
      sessionStorage.setItem('ndtType', shortcut.name)
      setNdtExitPath('/loft-selection')
      navigate(ndtFormPath(shortcut.name) ?? '/company')
      return
    }

    sessionStorage.setItem('inspectionType', 'loft')
    sessionStorage.setItem('loftType', shortcut.kind)
    sessionStorage.removeItem('loftExitPath')

    if (shortcut.kind === 'sammeliste') {
      // Sammeliste has its own multi-step flow
      navigate('/samleliste-flow')
    } else {
      navigate('/company')
    }
  }

  return (
    <div className="min-h-full p-4 sm:p-8" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="max-w-3xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {LIFTING_SHORTCUTS.map((shortcut) => (
            <ShortcutTile key={shortcut.name} shortcut={shortcut} onSelect={handleSelection} size="lg" />
          ))}
        </div>
      </div>
    </div>
  )
}

export default LoftSelection
